import { useModal } from "context";
import { ResetPasswordForm } from "modals";
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";

import styles from "./styles.module.scss";
const ResetPasswordPage = () => {
  const { email, token } = useParams();
  const { openModal, closeModal } = useModal();

  useEffect(() => {
    // Open reset password modal when page loads
    openModal({
      content: <ResetPasswordForm email={email} token={token} />,
    });
  }, [email, token]);

  return <div className={styles.resetFormContainer}></div>;
};

export default ResetPasswordPage;
